// Facebook Pixel implementation
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

// Initialize Facebook Pixel
if (typeof window !== 'undefined') {
  const pixelId = import.meta.env.VITE_FACEBOOK_PIXEL_ID;

  if (!pixelId) {
    console.warn('Facebook Pixel ID is not set. Retargeting will not be tracked.');
  } else {
    // Facebook Pixel base code
    (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    // Initialize the pixel
    window.fbq('init', pixelId);

    // Track PageView - this creates your retargeting audience
    window.fbq('track', 'PageView');

    if (import.meta.env.DEV) {
      console.log('Facebook Pixel initialized with ID:', pixelId);
    }
  }
}

// Export tracking function for custom events (if needed later)
export const trackFacebookEvent = (eventName: string, parameters?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, parameters);
  }
};

// Export page view tracking for SPA navigation
export const trackFacebookPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export default window?.fbq || (() => {});